import { watch } from 'vue'
import { useUserStore } from '@/stores/UserStore'

const CANNY_APP_ID = import.meta.env.VITE_CANNY_APP_ID

const loadSDK = () => {
  if (document.getElementById('canny-jssdk')) return
  ;(function (w, d, i, s) {
    function l() {
      if (!d.getElementById(i)) {
        const f = d.getElementsByTagName(s)[0]
        const e = d.createElement(s)
        e.type = 'text/javascript'
        e.async = true
        e.src = 'https://sdk.canny.io/sdk.js'
        e.id = i
        f.parentNode.insertBefore(e, f)
      }
    }
    if (typeof w.Canny !== 'function') {
      const c = function () { c.q.push(arguments) }
      c.q = []
      w.Canny = c
      if (d.readyState === 'complete') {
        l()
      } else if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  })(window, document, 'canny-jssdk', 'script')
}

const identify = (user) => {
  if (!CANNY_APP_ID || !user?.id || !user?.email) return
  try {
    window.Canny('identify', {
      appID: CANNY_APP_ID,
      user: {
        id: String(user.id),
        email: user.email,
        name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email,
        created: user.created_at ? new Date(user.created_at).toISOString() : undefined,
      },
    })
  } catch (e) {
    console.error('Canny identify failed:', e)
  }
}

export const useCanny = () => {
  const userStore = useUserStore()

  loadSDK()

  watch(() => userStore.user, (user) => {
    if (user) identify(user)
  }, { immediate: true })
}
